import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  House,
  Gear,
  Gift,
  PeopleFill,
  FileEarmarkTextFill,
  List,
  X,
} from "react-bootstrap-icons";
import "./style.css";

const Marketingsidebar = ({ isOpen, setIsOpen }) => {
  const toggleSidebar = () => setIsOpen(!isOpen);

  const closeSidebar = () => setIsOpen(false);

  return (
    <div className={`marketing-sidebar-menu ${isOpen ? "is-open" : ""}`}>
      {/* Hamburger Button - Only visible on mobile */}
      <div className="marketing-sidebar-toggle d-block d-lg-none">
        <button
          className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
          onClick={toggleSidebar}
          aria-expanded={isOpen}
          aria-label={isOpen ? "Close marketing menu" : "Open marketing menu"}
        >
          {isOpen ? <X size={24} /> : <List size={24} />}
          <span className="fw-medium">Menu</span>
        </button>
      </div>

      {/* Sidebar Content */}
      <div
        className={`marketing-sidebar-content d-flex flex-column h-100 ${
          isOpen ? "is-open" : ""
        }`}
      >
        <div className="p-3 pt-4 d-flex flex-column flex-grow-1">
          {/* Optional Title - hidden on mobile unless menu open */}
          <h5
            className="fw-bold  text-center mb-4 d-none d-lg-block"
            style={{ color: "#0353a4" }}
          >
            Marketing Panel
          </h5>

          <div className="d-flex flex-column gap-2">
            <NavLink
              to="/marketing-dashboard"
              className={({ isActive }) =>
                `d-flex align-items-center px-3 py-2 rounded-3 text-decoration-none font_14 ${
                  isActive ? "active-class-m text-white" : "text-dark"
                }`
              }
              style={{ fontWeight: "500" }}
              onClick={closeSidebar}
            >
              <House className="me-3" size={20} />
              Dashboard
            </NavLink>

            <NavLink
              to="/marketing-guidelines"
              className={({ isActive }) =>
                `d-flex align-items-center px-3 py-2 rounded-3 text-decoration-none font_14 ${
                  isActive ? "active-class-m text-white" : "text-dark"
                }`
              }
              style={{ fontWeight: "500" }}
              onClick={closeSidebar}
            >
              <FileEarmarkTextFill className="me-3" size={20} />
              Marketing Guideline
            </NavLink>

            <NavLink
              to="/marketing-clients"
              className={({ isActive }) =>
                `d-flex align-items-center px-3 py-2 rounded-3 text-decoration-none font_14 ${
                  isActive ? "active-class-m text-white" : "text-dark"
                }`
              }
              style={{ fontWeight: "500" }}
              onClick={closeSidebar}
            >
              <PeopleFill className="me-3" size={20} />
              My Clients
            </NavLink>

            <NavLink
              to="/marketing-rewards"
              className={({ isActive }) =>
                `d-flex align-items-center px-3 py-2 rounded-3 text-decoration-none font_14 ${
                  isActive ? " active-class-m text-white" : "text-dark"
                }`
              }
              style={{ fontWeight: "500" }}
              onClick={closeSidebar}
            >
              <Gift className="me-3" size={20} />
              Level & Rewards
            </NavLink>

            <NavLink
              to="/marketing-setting"
              className={({ isActive }) =>
                `d-flex align-items-center px-3 py-2 rounded-3 text-decoration-none font_14 ${
                  isActive ? " active-class-m text-white" : "text-dark"
                }`
              }
              style={{ fontWeight: "500" }}
              onClick={closeSidebar}
            >
              <Gear className="me-3" size={20} />
              Settings
            </NavLink>
          </div>
        </div>
      </div>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="marketing-sidebar-overlay d-block d-lg-none position-fixed inset-0 bg-black bg-opacity-50"
          onClick={closeSidebar}
          aria-hidden="true"
        />
      )}
    </div>
  );
};

export default Marketingsidebar;
